import React, { createElement } from "react";
import TextLabel from "@components/ui/text-label";
import { h1 } from "../components/ui/typography/typography.module.css";
import { gap } from "./layout.module.css";

type HeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
interface LabelTitleDescriptionProps {
  label: string;
  title: string;
  children: React.ReactNode;
  heading?: HeadingType;
}

const LabelTitleDescription: React.FC<LabelTitleDescriptionProps> = ({
  label,
  title,
  children,
  heading = "h2"
}) => {
  const Heading = createElement(heading, { className: `${h1} text-dark` }, title);
  return (
    <>
      <TextLabel>{label}</TextLabel>
      <div className={`mt-6 md:flex ${gap}`}>
        <div className="w-full md:w-1/2 md:mr-2">{Heading}</div>
        <div className="w-full md:w-1/2 md:ml-2">{children}</div>
      </div>
    </>
  );
};

export default LabelTitleDescription;
